import { useContext } from "react";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "./state-machine/reviewBoardFlowLoader";
import { useAppDispatch } from "../../store";
import useSendBoardEvent, {
  BoardTransitionEvent,
  MachineGroup,
} from "./state-machine/sendBoardEvent";
import { pageFailure } from "../../../../reducers/uploadedBoard";
import {
  BoardUploadFileType,
  DownloadableFileResponse,
  UploadFilesResponse,
  useUploadBoardFiles,
} from "../../uploadToS3";
import { UploadFileType } from "../../../../components/UploadBoard/AdditionalImageFilesUpload";
import useGetCustomerImageFiles from "./getCustomerImageFiles";

function useCustomerImageFiles() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const dispatch = useAppDispatch();
  const errorHandler = () => {
    dispatch(pageFailure({ boardId }));
  };
  const { refreshCustomerFilesResponse } = useGetCustomerImageFiles();
  const { sendBoardEvent, loading } = useSendBoardEvent(
    errorHandler,
    refreshCustomerFilesResponse,
  );
  const { uploadBoardFiles, sending } = useUploadBoardFiles(
    errorHandler,
    BoardUploadFileType.CUSTOMER_IMAGE,
  );

  const saveCustomerImageFiles = (
    boardId: string,
    files: File[],
    fileType: UploadFileType,
  ) => {
    const saveCustomerImageFilesAfterUpload = async (
      fileLinks: UploadFilesResponse,
    ) => {
      await sendBoardEvent(boardId, {
        machine_group: MachineGroup.BOARD,
        model_id: boardId,
        event: BoardTransitionEvent.CUSTOMER_FILES_UPLOADED,
        update: {
          file_type: fileType,
          customer_image_files: fileLinks.upload_data.map((uploadData) => ({
            file_name: uploadData.file_name,
            s3_key: uploadData.s3_key,
          })),
        },
      });
    };
    uploadBoardFiles(boardId, files, saveCustomerImageFilesAfterUpload);
  };

  const removeCustomerImageFile = (attachment: DownloadableFileResponse) => {
    void sendBoardEvent(boardId, {
      machine_group: MachineGroup.BOARD,
      model_id: boardId,
      event: BoardTransitionEvent.REMOVE_CUSTOMER_FILE,
      update: {
        s3_key: attachment.s3_key,
      },
    });
  };

  return {
    saveCustomerImageFiles,
    removeCustomerImageFile,
    loading: loading || sending,
  };
}

export default useCustomerImageFiles;
